/* mo-prot.js: the mattress protectors page (sections/mo-prot.liquid), 2026-10-14.
   1. One size picker routes every tier (ladder, table header, item number) to that size's product and live price.
   2. "Will it reach": the side of a mattress at the chosen height with Ashley's 18 in. skirt drawn on it
      (tucks under when it reaches, rides up when it does not). Heights of real MO beds come from the live
      /collections/mattresses?view=mo-mx-data feed. Drawing units are inches.
   The server HTML is complete without this file (Queen view, every size linked). */
(function () {
  'use strict';
  var FIT = 18; // Ashley: "Fits mattresses up to 18" thick" (M30803P, M30903P, M31003P)
  var NAMES = { twin: 'Twin', txl: 'Twin XL', full: 'Full', queen: 'Queen', king: 'King', cal: 'Cal King' };
  var TIERS = { basic: 'Basic', advanced: 'Advanced', cooling: 'Extra Cooling', tencel: 'Premium Tencel' };

  function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function txt(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function fmtIn(h) { return (Math.round(h * 100) / 100).toString(); }

  /* ---------- fit drawing (also used at build time to write the server copy) ---------- */
  function fitSVG(h) {
    h = Math.round(h * 4) / 4; // labels and geometry move in quarter inches while the drawing eases
    var L = 34, T = 3.2, r = 1.1, d = Math.min(h, FIT), B = T + h, out = [];
    var tuck = FIT - h, short = h - FIT, cx = L - 13; // the protector is cut away left of cx so the mattress shows
    // foundation, then the mattress: quilted top panel, border with stitching, tape edges, a handle
    out.push('<rect class="pf-base" x="-1" y="' + (B + .15) + '" width="' + (L + 1.6) + '" height="2.6" rx=".4"/>');
    out.push('<path class="pf-mat" d="M0 ' + T + 'H' + (L - r) + 'Q' + L + ' ' + T + ' ' + L + ' ' + (T + r) + 'V' + (B - r) + 'Q' + L + ' ' + B + ' ' + (L - r) + ' ' + B + 'H0Z"/>');
    var q = Math.min(2.4, h * .22), qp = 'M0 ' + (T + q);
    for (var x = 0; x < L - .6; x += 2.2) qp += 'Q' + (x + 1.1) + ' ' + (T + q * .35) + ' ' + Math.min(L - .6, x + 2.2) + ' ' + (T + q);
    out.push('<path class="pf-quilt" d="' + qp + '"/>');
    for (x = 1.4; x < L - .8; x += 1.4) out.push('<line class="pf-stitch" x1="' + x + '" y1="' + (T + q + .5) + '" x2="' + x + '" y2="' + (B - .6) + '"/>');
    out.push('<path class="pf-tape" d="M0 ' + (T + .15) + 'H' + (L - r) + 'Q' + (L - .15) + ' ' + (T + .15) + ' ' + (L - .15) + ' ' + (T + r) + 'V' + (B - r) + 'Q' + (L - .15) + ' ' + (B - .15) + ' ' + (L - r) + ' ' + (B - .15) + 'H0"/>');
    var hy = T + q + (h - q) * .5, hx = L * .38;
    out.push('<rect class="pf-handle" x="' + hx + '" y="' + (hy - .55) + '" width="6" height="1.1" rx=".55"/>');
    // protector: face over the whole top, skirt down the corner to Ashley's 18 in.
    out.push('<rect class="pf-face" x="0" y="' + (T - .5) + '" width="' + (L - r + .3) + '" height=".6" rx=".2"/>');
    var sb = T + d, zig = '';
    for (var zy = T + .1; zy < sb - .01; zy += 1) zig += 'L' + (cx + ((Math.round((zy - T) / 1) % 2) ? .45 : 0)) + ' ' + Math.min(sb, zy + 1);
    var sk = 'M' + cx + ' ' + (T - .5) + 'H' + (L - r + .2) + 'Q' + (L + .45) + ' ' + (T - .5) + ' ' + (L + .45) + ' ' + (T + r);
    if (short > 0) sk += 'V' + sb + 'H' + cx;
    else sk += 'V' + (B - r) + 'Q' + (L + .45) + ' ' + (B + .45) + ' ' + (L - r) + ' ' + (B + .45) + 'H' + cx + 'V' + sb;
    out.push('<path class="pf-skirt" d="' + sk + zig + 'Z"/>');
    for (var k = 1; k * .7 < d; k++) out.push('<line class="pf-knit" x1="' + (cx + .6) + '" y1="' + (T + k * .7) + '" x2="' + (L + .2) + '" y2="' + (T + k * .7) + '"/>');
    if (tuck >= 0) {
      // the spare skirt runs under the mattress, between it and the foundation, and ends in the elastic
      var tl = Math.max(.3, tuck), ex = L - r - tl;
      out.push('<path class="pf-tuck" d="M' + (L - r) + ' ' + (B + .2) + 'H' + ex + '"/>');
      out.push('<path class="pf-elastic" d="M' + (ex + .1) + ' ' + (B - .1) + 'q-.25 .15 0 .3t0 .3"/>');
      out.push('<text class="pf-t pf-t--sm" x="' + (ex + tl / 2) + '" y="' + (B + 3.6) + '" text-anchor="middle">tucks ' + fmtIn(tuck) + ' in. under</text>');
      out.push('<path class="pf-lead" d="M' + (ex + tl / 2) + ' ' + (B + .7) + 'V' + (B + 2.7) + '"/>');
    } else {
      // too tall: the elastic hem stops short of the bottom edge and pulls the corner up
      out.push('<path class="pf-hemline" d="M' + cx + ' ' + sb + 'H' + (L + .45) + '"/>');
      out.push('<path class="pf-ride" d="M' + (L - 6) + ' ' + (sb + 2.4) + 'V' + (sb + .5) + 'M' + (L - 6.6) + ' ' + (sb + 1.2) + 'L' + (L - 6) + ' ' + (sb + .5) + 'L' + (L - 5.4) + ' ' + (sb + 1.2) + '"/>');
      out.push('<path class="pf-lead" d="M' + (L - 6) + ' ' + (sb + 2.6) + 'V' + (B + 2.7) + '"/>');
      out.push('<text class="pf-t pf-t--red pf-t--sm" x="' + (L - 6) + '" y="' + (B + 3.6) + '" text-anchor="middle">' + fmtIn(short) + ' in. short, rides up</text>');
    }
    // dimensions: the mattress in red, Ashley's fit in ink
    var dx = L + 3.4, fx = L + 10.2;
    out.push('<g class="pf-dim"><path d="M' + dx + ' ' + T + 'V' + B + 'M' + (dx - .5) + ' ' + T + 'H' + (dx + .5) + 'M' + (dx - .5) + ' ' + B + 'H' + (dx + .5) + '"/></g>');
    out.push('<g class="pf-dim2"><path d="M' + fx + ' ' + T + 'V' + (T + FIT) + 'M' + (fx - .5) + ' ' + T + 'H' + (fx + .5) + 'M' + (fx - .5) + ' ' + (T + FIT) + 'H' + (fx + .5) + '"/></g>');
    out.push('<text class="pf-t pf-t--red" x="' + (dx + .7) + '" y="' + (T + h / 2) + '">' + fmtIn(h) + ' in.</text>');
    out.push('<text class="pf-t pf-t--sm" x="' + (dx + .7) + '" y="' + (T + h / 2 + 1.5) + '">bed</text>');
    out.push('<text class="pf-t" x="' + (fx + .7) + '" y="' + (T + FIT / 2) + '">18 in.</text>');
    out.push('<text class="pf-t pf-t--sm" x="' + (fx + .7) + '" y="' + (T + FIT / 2 + 1.5) + '">fit</text>');
    out.push('<text class="pf-t pf-t--sm" x="' + (cx + 6.5) + '" y="' + (T - 1.6) + '" text-anchor="middle">protector</text>');
    return out.join('');
  }

  function fitVerdict(h) {
        if (h < FIT - .01) return 'Fits. The skirt tucks about ' + fmtIn(FIT - h) + ' in. under.';
    if (h <= FIT + .01) return 'Just fits. The skirt reaches the bottom edge.';
    return 'Too tall by ' + fmtIn(h - FIT) + ' in. The skirt stops short and rides up.';
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { fitSVG: fitSVG, fitVerdict: fitVerdict }; return; }

  function Page(root) {
    this.root = root;
    try { this.m = JSON.parse(root.querySelector('[data-prot-matrix]').textContent); } catch (e) { this.m = null; }
    var self = this;
    root.querySelectorAll('[data-prot-sizes] input').forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) self.size(i.value, true); });
    });
    var saved = null;
    try { saved = sessionStorage.getItem('moProtSize'); } catch (e) {}
    if (saved && NAMES[saved] && saved !== root.getAttribute('data-size')) {
      var r = root.querySelector('[data-prot-sizes] input[value="' + saved + '"]');
      if (r) { r.checked = true; this.size(saved, false); }
    }
    this.fit();
  }

  Page.prototype.size = function (k, announce) {
    if (!this.m) return;
    var root = this.root, m = this.m, parts = [];
    root.setAttribute('data-size', k);
    try { sessionStorage.setItem('moProtSize', k); } catch (e) {}
    root.querySelectorAll('[data-prot-size-name], [data-prot-size-short]').forEach(function (el) { txt(el, NAMES[k]); });
    root.querySelectorAll('[data-prot-tier]').forEach(function (el) {
      var t = el.getAttribute('data-prot-tier'), v = m[t] && m[t][k];
      var link = el.querySelector('[data-prot-link]');
      if (link) {
        if (v) {
          if (link.tagName === 'A') link.setAttribute('href', v.u);
          link.removeAttribute('aria-disabled'); link.classList.remove('is-none');
        } else {
          link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); link.classList.add('is-none');
        }
      }
      var pr = el.querySelector('[data-prot-price]');
      if (pr) txt(pr, v ? money(v.p) : 'Not made in this size');
      var was = el.querySelector('[data-prot-was]');
      if (was) { was.hidden = !(v && v.c > v.p); txt(el.querySelector('[data-prot-was-v]'), v && v.c > v.p ? money(v.c) : ''); }
      txt(el.querySelector('[data-prot-sku]'), v ? (v.s || '') : 'Not made');
      if (el.classList.contains('prot-step') && v) parts.push(TIERS[t] + ' ' + money(v.p));
    });
    root.querySelectorAll('[data-prot-size-row]').forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-prot-size-row') === k); });
    if (announce) txt(root.querySelector('[data-prot-live]'), NAMES[k] + ': ' + parts.join(', ') + '.');
  };

  Page.prototype.fit = function () {
    var box = this.root.querySelector('[data-prot-fit]');
    if (!box) return;
    var svg = box.querySelector('[data-fit-g]'), range = box.querySelector('[data-fit-range]'), out = box.querySelector('[data-fit-out]');
    var verdict = box.querySelector('[data-fit-verdict]'), who = box.querySelector('[data-fit-who]'), picks = box.querySelector('[data-fit-picks]');
    var raf = 0, cur = parseFloat(range.value), target = cur, label = '';
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function paint(h) { svg.innerHTML = fitSVG(h); }
    function settle(h, name) {
      target = h; label = name || '';
      txt(out, fmtIn(h) + ' in.');
      txt(who, name ? name + ', ' + fmtIn(h) + ' in.' : 'Your mattress');
      txt(verdict, fitVerdict(h));
      box.classList.toggle('is-short', h > FIT + .01);
      if (reduced) { cur = h; paint(h); return; }
      if (!raf) raf = requestAnimationFrame(function step() {
        cur += (target - cur) * .22;
        if (Math.abs(target - cur) < .02) cur = target;
        paint(cur);
        raf = cur === target ? 0 : requestAnimationFrame(step);
      });
    }
    range.addEventListener('input', function () {
      picks && picks.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      settle(parseFloat(range.value), '');
    });
    box.classList.add('is-live');
    settle(cur, '');
    // real beds from the all-mattresses feed, fetched when the section comes near
    var feed = this.root.getAttribute('data-feed'), fact = box.querySelector('[data-fit-fact]'), done = false;
    function load() {
      if (done || !feed) return; done = true;
      fetch(feed, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var beds = [];
        (d.products || []).forEach(function (p) {
          if (!p || !p.ht) return;
          var h = parseFloat(String(p.ht));
          if (isFinite(h) && h > 3 && h < 30) beds.push({ n: p.t.replace(/\s*Mattress$/i, '').replace(/[®™]/g, ''), h: h, u: '/products/' + p.h });
        });
        if (!beds.length) return;
        beds.sort(function (a, b) { return a.h - b.h; });
        var tall = beds[beds.length - 1], over = beds.filter(function (b) { return b.h > FIT; }).length;
        if (fact) {
          fact.innerHTML = '';
          var s1 = document.createElement('span');
          s1.textContent = 'Of ' + beds.length + ' mattresses we list with a height, the tallest is ';
          var a = document.createElement('a'); a.href = tall.u; a.textContent = tall.n;
          var s2 = document.createElement('span');
          s2.textContent = ' at ' + fmtIn(tall.h) + ' in. ' + (over ? over + ' are taller than 18 in.' : 'Every one is within the 18 in. fit.');
          fact.appendChild(s1); fact.appendChild(a); fact.appendChild(s2); fact.hidden = false;
        }
        var want = [beds[0].h, 10, 12, 14, 16, tall.h], chosen = [];
        want.forEach(function (w) {
          var best = null;
          beds.forEach(function (b) { if (chosen.indexOf(b) < 0 && (!best || Math.abs(b.h - w) < Math.abs(best.h - w))) best = b; });
          if (best && !chosen.some(function (c) { return c.h === best.h; })) chosen.push(best);
        });
        chosen.sort(function (a, b) { return a.h - b.h; });
        if (!picks) return;
        chosen.forEach(function (b) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'prot-chip prot-chip--pick'; btn.setAttribute('aria-pressed', 'false');
          var nm = document.createElement('span'); nm.className = 'prot-chip__n'; nm.textContent = b.n;
          var ht = document.createElement('span'); ht.className = 'prot-chip__h'; ht.textContent = fmtIn(b.h) + ' in.';
          btn.appendChild(nm); btn.appendChild(ht);
          btn.addEventListener('click', function () {
            picks.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
            range.value = Math.min(parseFloat(range.max), b.h);
            settle(b.h, b.n);
          });
          picks.appendChild(btn);
        });
        picks.hidden = false;
      }).catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(box);
    } else load();
  };

  function mount() {
    document.querySelectorAll('[data-prot]').forEach(function (el) { if (!el.__prot) el.__prot = new Page(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
